import { stageAddition } from "../helpers";
import _ from 'lodash';

function powerSeries(data) {
  let { derivedData, dataMapping } = data.reduce((acc, item) => {
    let
      // wl = item[0],
      // x = stageAddition(wl, h0 * -1),
      x = item[0],
      y = item[1],
      X = Math.log(x),
      X2 = X * X,
      Y = Math.log(y),
      XY = X * Y;

    if (!acc.derivedData.min_x || acc.derivedData.min_x > x) acc.derivedData.min_x = x;
    if (!acc.derivedData.max_x || acc.derivedData.max_x < x) acc.derivedData.max_x = x;
    acc.derivedData.sum_X = (acc.derivedData.sum_X || 0) + X;
    acc.derivedData.sum_Y = (acc.derivedData.sum_Y || 0) + Y;
    acc.derivedData.sum_XY = (acc.derivedData.sum_XY || 0) + XY;
    acc.derivedData.sum_X2 = (acc.derivedData.sum_X2 || 0) + X2;
    acc.dataMapping[x] = y;
    return acc;
  }, { derivedData: {}, dataMapping: {} });

  let
    n = data.length,
    { min_x, max_x, sum_X, sum_Y, sum_XY, sum_X2 } = derivedData,

    B = ((sum_Y * sum_X) - (n * sum_XY)) / ((sum_X * sum_X) - (n * sum_X2)),
    A = (sum_Y - (B * sum_X)) / n,

    a = Math.exp(A),
    b = B;

  let normalSeries = [];
  let logSeries = [];
  let errors = [];

  let i = min_x;
  while (i <= max_x) {
    let
      x = i,
      y = a * (x ** b),
      X = Math.log(x),
      Y = A + (B * X);

    // wl = stageAddition(x, h0),
    // log_wl = Math.log(wl);
    // if (!!dataMapping[x]) {
    //   errors.push((dataMapping[x] - y) ** 2);
    // }
    let all_obs_for_x = data.filter(item => +item[0] === +x);
    all_obs_for_x.forEach(obs_data => {
      let obs_y = obs_data[1];
      errors.push((obs_y - y) ** 2);
    });

    normalSeries.push([x, y]);
    logSeries.push([X, Y])
    i = stageAddition(i)
  }

  return {
    normalSeries,
    logSeries,
    parameters: {
      A, B, a, b, rmse: Math.sqrt(_.mean(errors))
    }
  };
}

export default powerSeries;


// WEBPACK FOOTER //
// ./src/components/Hydrology/RTEquations/scripts/power.js